import { SystemStyleObject } from '@chakra-ui/react';
import { ColorMode } from '@allergan-data-labs/alle-elements-core';

export const getActionContentStyles = (
  colorMode: ColorMode,
  hasFooter: boolean
): SystemStyleObject => {
  const styles: SystemStyleObject = {
    overflowX: 'hidden',
    overflowY: 'auto',
    bg: `${colorMode}.Container/Neutral/Base`,
    color: `${colorMode}.Text/Neutral/Default`,
    padding: '8',
    maxHeight: '35vh',
    border: 'none',
    boxShadow: 'Elevation/2',
    borderRadius: '8',
    '.chakra-menu__group:not(:first-of-type)': {
      borderTop: '1px',
      borderColor: `${colorMode}.Border/Neutral/Subtle 2`,
      paddingTop: '8',
      marginTop: '8',
    },
    '.action-menu__header + .chakra-menu__group': {
      borderTop: '0',
    },
  };

  if (hasFooter) {
    delete styles.padding;
    styles.paddingTop = '8';
    styles.paddingLeft = '8';
    styles.paddingRight = '8';
    styles.paddingBottom = '0';
  }

  return styles;
};
